let mapMarkers = [];
let mapWindows = [];

let map;
function initMap() {

    map = new google.maps.Map(document.getElementById("map"), {
        center: {
            lat: 55.86634446616404,
            lng: -4.2180701859773
        },
        zoom: 7,
        streetViewControl: false,
        mapTypeControl: false,
        styles: [{
            "elementType": "geometry",
            "stylers": [{
                "color": "#333333"
            }]
        }, {
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#757575"
            }]
        }, {
            "elementType": "labels.text.stroke",
            "stylers": [{
                "color": "#212121"
            }]
        }, {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [{
                "color": "#757575"
            }]
        }, {
            "featureType": "administrative.country",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#9e9e9e"
            }]
        }, {
            "featureType": "administrative.land_parcel",
            "stylers": [{
                "visibility": "off"
            }]
        }, {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#bdbdbd"
            }]
        }, {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#757575"
            }]
        }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
                "color": "#181818"
            }]
        }, {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#616161"
            }]
        }, {
            "featureType": "poi.park",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "color": "#1b1b1b"
            }]
        }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#2c2c2c"
            }]
        }, {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#8a8a8a"
            }]
        }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
                "color": "#373737"
            }]
        }, {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [{
                "color": "#3c3c3c"
            }]
        }, {
            "featureType": "road.highway.controlled_access",
            "elementType": "geometry",
            "stylers": [{
                "color": "#4e4e4e"
            }]
        }, {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#616161"
            }]
        }, {
            "featureType": "transit",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#757575"
            }]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
                "color": "#111111"
            }]
        }, {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#202020"
            }]
        }],
    });

    const iconBase = "assets/img/svg/icons/";

    const icons = {
        info: {
            icon: iconBase + "indicator.svg",
        },
        current: {
            icon: iconBase + "currentindicator.svg",
        }
    };

    const GMAPList = [];
    const GMAPFeatures = [];

    const loadGMAPitems = async(url) => {
        const jsonres = await fetch(url);
        jsonList = await jsonres.json();
        createFeatures(jsonList);
    }

    const createFeatures = (GMAPItems) => {
        const features = GMAPItems.map((GMAPItem) => {
            let lat = parseFloat(GMAPItem.lat);
            let lng = parseFloat(GMAPItem.lng);
            let feature = {
                "is_location": GMAPItem.location,
                "location_slug": GMAPItem.slug,
                "position": new google.maps.LatLng(lat, lng),
                "type": GMAPItem.type,
                "content": `
                <h4 style='font-size:17px;letter-spacing:0.005rem;margin-bottom:7px;color:#202020'>${GMAPItem.title}</h4>
                <div style='font-size:15px;font-weight:500;color:#333333;'>
                    <span style='margin:0 2px 0 0;display:inline-block;'>Tel:</span>
                    <span>${GMAPItem.tel}</span>
                </div>
                <button class="buttonClick" onclick="initPrimary(event)" data-slug="${GMAPItem.slug}" style='background-color:#FBBB2C;width:100%;padding:7px 10px;font-weight:600;font-size:15px;display: flex;align-items: center;line-height: 100%;border-radius: 2px;margin-top: 15px;'>View Details</button>`
            };
            GMAPFeatures.push(feature);
        });

        let prev_infowindow = false; 
        let prev_marker = false; 

        for (let i = 0; i < GMAPFeatures.length; i++) {
            if(GMAPFeatures[i].is_location && GMAPFeatures[i].is_location.length){
                const marker = new google.maps.Marker({
                    marker_slug: GMAPFeatures[i].location_slug,
                    position: GMAPFeatures[i].position,
                    icon: icons.info.icon,
                    map: map,
                });

                mapMarkers.push(marker);

                const infowindow = new google.maps.InfoWindow({
                    content: GMAPFeatures[i].content,
                    window_slug: GMAPFeatures[i].location_slug,
                });

                mapWindows.push(infowindow);

                marker.addListener("click", () => {
                    for (i in mapMarkers){
                        mapMarkers[i].setIcon(icons.info.icon);
                    }
                    marker.setIcon(icons.current.icon);
                    map.setCenter(marker.getPosition())
                    if( prev_infowindow ) {
                        prev_infowindow.close();
                    };

                    if( prev_marker ) {
                        prev_marker.setIcon(icons.info.icon);
                    };

                    prev_infowindow = infowindow;
                    prev_marker = marker;

                    infowindow.open({
                        anchor: marker,
                        map,
                        shouldFocus: false,
                    });

                    google.maps.event.addListener(map, 'click', function() {
                        infowindow.close();
                        marker.open = false;
                    });
                });
            }
        }
    };
    loadGMAPitems(mapJSONUrl);
}


function initPrimary(event) {
    const primaryDepotBox = document.querySelector('.depot-contact-box.primary');
    const depotSlug = event.currentTarget.getAttribute('data-slug');

    const updatePrimaryJSON = async(mapJSONUrl , depotSlug) => {
        const jsonres = await fetch(mapJSONUrl);
        jsonList = await jsonres.json();
        updatePrimaryDepot(jsonList , depotSlug);
    }
    
    changeMarker(depotSlug);
    changeWindow(depotSlug);
    updatePrimaryJSON(mapJSONUrl , depotSlug);

    if(event.currentTarget.classList.contains('buttonClick')){
        primaryDepotBox.scrollIntoView({
            behavior: "auto"
        });
    }

}

function changeMarker(marker_slug){
    for (let i = 0; i < mapMarkers.length; i++){
        mapMarkers[i].setIcon('assets/img/svg/icons/indicator.svg');
        if(mapMarkers[i].marker_slug == marker_slug){
            mapMarkers[i].setIcon('assets/img/svg/icons/currentindicator.svg');
            map.setCenter(mapMarkers[i].getPosition())
        }
    }
}

function changeWindow(window_slug){
    for (let i = 0; i < mapWindows.length; i++){
        if(mapWindows[i].window_slug == window_slug){
            mapWindows[i].close();
        }
    }
}

function updatePrimaryDepot(JSONList , depotSlug) {
    const primaryDepotBox = document.querySelector('.depot-contact-box');
    for (let i = 0; i < JSONList.length; i++) {
        if(JSONList[i].slug == depotSlug){
            const primaryDepotTitle = primaryDepotBox.querySelector('.depot-title');
            const primaryDepotTel = primaryDepotBox.querySelector('.depot-tel-value');
            const primaryDepotEmail = primaryDepotBox.querySelector('.depot-email-value');
            const primaryDepotAddress = primaryDepotBox.querySelector('.depot-address-value');
            const primaryDepotOpeningHours = primaryDepotBox.querySelector('.depot-opening-hours');

            const openingHoursVals = [];

            let hasFriday = false;

            primaryDepotTitle.textContent = JSONList[i].title;
            primaryDepotTel.textContent = JSONList[i].tel;
            primaryDepotEmail.textContent = JSONList[i].email;
            primaryDepotAddress.textContent = JSONList[i].address;

            if(JSONList[i].opening_hours.monfri){
                openingHoursVals.push({'monfri':JSONList[i].opening_hours.monfri});
            }
            if(JSONList[i].opening_hours.fri){
                hasFriday = true;
                openingHoursVals.push({'Fri':JSONList[i].opening_hours.monfri});
            }
            if(JSONList[i].opening_hours.sat){
                openingHoursVals.push({'Sat':JSONList[i].opening_hours.sat});
            }
            if(JSONList[i].opening_hours.sun){
                openingHoursVals.push({'Sun':JSONList[i].opening_hours.sun});
            }

            let depotOpenHoursHTML = '';

            for (let y = 0; y < openingHoursVals.length; y++) {
                let dateOfWeek = Object.keys(openingHoursVals[y])[0];
                let hoursOfDate = Object.values(openingHoursVals[y])[0];
                let labelValue
                if(dateOfWeek == 'monfri' && hasFriday == true){
                    labelValue = 'Mon - Thur';
                }else if(dateOfWeek == 'monfri' && hasFriday != true){
                    labelValue = 'Mon - Fri';
                }else{
                    labelValue = dateOfWeek;
                }
                
                let depotItemHTML = `
                <div class="depot-info-item">
                    <i class="sj--icon-time"></i>
                    <span class="depot-item-label">${labelValue}:</span>
                    <span class="depot-mon-fri-value">${hoursOfDate}</span>
                </div>
                `;

                depotOpenHoursHTML = depotOpenHoursHTML + depotItemHTML;
            }
            primaryDepotOpeningHours.innerHTML = '';
            primaryDepotOpeningHours.insertAdjacentHTML(
                'beforeend',
                depotOpenHoursHTML,
            );
        }
    }

    const depotList = document.querySelectorAll('.depot-slide[data-primary]');
    for (let i = 0; i < depotList.length; i++) {
        depotList[i].setAttribute('data-primary' , '')
    }

    const primaryDepot = document.querySelector('.depot-slide[data-slug="' + depotSlug + '"]');
    primaryDepot.setAttribute('data-primary' , 'true');
}


document.arrive('.depot-location', { existing: true }, function() {
    const depotButtons = document.querySelectorAll('.depot-location');
    for (let i = 0; i < depotButtons.length; i++) {
        depotButtons[i].addEventListener('click', (event) => {
            initPrimary(event);
            const primaryDepotBox = document.querySelector('.depot-contact-box');
            primaryDepotBox.scrollIntoView({
                behavior: "auto"
            });
        });
    }
});
